import type { SchemaDefinition } from '../types/localDb.types'

/** Relasi tabel platform & Workflow Studio (subset 22 tabel core) yang diekspansi oleh `fields=fk.*`. */
export const PLATFORM_SCHEMA: SchemaDefinition = {
  directus_users: { searchFields: ['first_name', 'last_name', 'email'] },
  mt_roles: { searchFields: ['code', 'name'] },
  mt_privileges: { relations: { user: 'directus_users', role: 'mt_roles' } },
  mt_products: { relations: { main_page: 'mt_pages' } },
  mt_modules: { relations: { product: 'mt_products' } },
  mt_clusters: { relations: { module: 'mt_modules' } },
  mt_pages: { relations: { cluster: 'mt_clusters' } },
  trx_product_pages: { relations: { product: 'mt_products', page: 'mt_pages' } },
  mt_capabilities: { relations: { role: 'mt_roles', page: 'mt_pages' } },
  mt_product: { searchFields: ['code', 'name'] },
  mt_workcenters: { searchFields: ['code', 'name'] },
  mt_equipment: { relations: { workcenter_id: 'mt_workcenters' }, searchFields: ['code', 'name'] },
  wml_workflow: {
    aliases: { statuses: { collection: 'wml_status', field: 'workflow_id' } }
  },
  wml_status: { relations: { workflow_id: 'wml_workflow' } },
  wml_component: { relations: { workflow_id: 'wml_workflow' } },
  wml_action: {
    relations: {
      workflow_id: 'wml_workflow',
      from_status_id: 'wml_status',
      to_status_id: 'wml_status',
      component_id: 'wml_component'
    }
  },
  wml_actor: { relations: { workflow_id: 'wml_workflow', role_id: 'mt_roles', direct_user_id: 'directus_users' } },
  wml_action_actor_eligibility: { relations: { action_id: 'wml_action', actor_id: 'wml_actor' } },
  wml_panel: { relations: { component_id: 'wml_component', status_id: 'wml_status' } },
  wml_panel_actor_eligibility: { relations: { panel_id: 'wml_panel', actor_id: 'wml_actor' } },
  wxl_submission: {
    relations: {
      workflow_id: 'wml_workflow',
      current_status_id: 'wml_status',
      last_action_id: 'wml_action',
      user_created: 'directus_users'
    },
    aliases: { wxl_submission_logs: { collection: 'wxl_submission_log', field: 'submission_id' } }
  },
  wxl_submission_log: {
    relations: {
      workflow_id: 'wml_workflow',
      submission_id: 'wxl_submission',
      action_id: 'wml_action',
      actor_id: 'wml_actor',
      user_created: 'directus_users',
      from_status_id: 'wml_status',
      to_status_id: 'wml_status'
    }
  }
}
